import { Receipt } from "@phosphor-icons/react";
import { PolicyPage } from "@/components/PolicyPage";
import { REFUND_POLICY } from "@/data/business";

export default function RefundPolicy() {
  return (
    <PolicyPage
      testId="refund-policy-page"
      icon={Receipt}
      title="Refund Policy"
      intro="Plain English. All prices in Australian dollars (AUD). No GST applies."
      sections={REFUND_POLICY}
    >
      <a href="/refund-request" data-testid="refund-request-link"
        className="mt-6 inline-flex rounded-full bg-[#E06D53] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#C85B43]">
        Request a refund
      </a>
    </PolicyPage>
  );
}
